<div [style]="css | safeStyle" [innerHtml]="html"></div>
